export default "__VITE_ASSET__BCwHg1Rk__"